import { REFRESH_ADMIN_DATA_TRIGGER, refreshAdminDataMiddleware } from '@modules/admin/Admin.Dux'
import { fork, takeLeading } from 'redux-saga/effects'

import { authSaga } from './auth/auth.Dux'

export function* rootSaga() {
  try {
    yield fork(authSaga)
    yield takeLeading(REFRESH_ADMIN_DATA_TRIGGER, refreshAdminDataMiddleware)
  } catch (e) {
    yield console.error(e.message)
  }
}
